<template>
  <v-text-field
    v-model="search.value"
    append-icon="mdi-magnify"
    :label="label"
    color="primary"
    clearable
    outlined
    dense
    autocomplete="off"
  />
</template>

<script>
export default {
  name: "DatatableSearch",
  props: {
    label: {
      type: String,
      default: "Search",
    },
  },
  data: () => ({
    search: { value: null, regex: true },
  }),

  watch: {
    "search.value": _.debounce(function () {
      this.$emit("input", this.search);
      this.$emit("click", false);
    }, 700),
  },
};
</script>
